import { applyRequired, createResult, fail, ok, runFieldMap, toText } from "./shared.js";
import { parseBoolean, validateBooleanParsed, validateOneOf } from "./validators.js";
import { validateLocale } from "./profileFields.js";

export const localeFormFields = Object.freeze(["value", "isPermanent", "target"]);

const requiredFields = Object.freeze(["value"]);
const targetList = Object.freeze(["browser"]);

const finish = (value, error)=>error ? fail(value, error) : ok(value);

const validateIsPermanent = raw=>{
    const parsed = parseBoolean(raw, false);
    return finish(parsed.value, validateBooleanParsed(parsed));
};

const validateTarget = raw=>{
    const value = toText(raw, { max:32 });
    if (!value) { return ok(value); }
    return finish(value, validateOneOf(value, targetList));
};

const validators = Object.freeze({
    value:validateLocale,
    isPermanent:validateIsPermanent,
    target:validateTarget
});

export const validateLocaleForm = (input={})=>{
    const { values, fieldErrors } = runFieldMap(input, localeFormFields, validators);
    applyRequired(values, fieldErrors, requiredFields);
    return createResult(values, fieldErrors, []);
};
